// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 70 ? "8012d7e2" : chunkId) + "." + {"70":"c02a7336ecc9cf53","804":"ab9602f7aa5f0ccc"}[chunkId] + ".js";
};